import './App.css'
import { useEffect } from 'react';
import Container from './section/Container/Container'
import Footer from './section/Footer/Footer'
import Header from './section/Header/Header'
import Home from './pages/Home/Home'
import List from './pages/List/List'
import Add from './pages/Add/Add'
import House from './pages/House/House'
import { ToastContainer } from 'react-toastify';
import { HashRouter as Router, Route, Routes } from 'react-router-dom'
import AOS from 'aos';

const App = () => {
  useEffect(() => {
    AOS.init();
  }, [])


  return (
    <>
      <ToastContainer theme='colored' position='bottom-center' style={{"font-size":"15px"}}></ToastContainer>
      <Router>
        <Header />
        <Container>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/list' element={<List />} />
            <Route path='/list/:id' element={<House />} />
            <Route path='/add' element={<Add />} />
          </Routes>
        </Container>
        <Footer />
      </Router>
    </>
  )
}

export default App
